import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/IGBTModulesModernElectronicsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-IGBT.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .cgip { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .cgip-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .cgip-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .cgip-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .cgip-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .cgip-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .cgip-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .cgip-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .cgip-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .cgip-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .cgip-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .cgip-bc-item:hover { color: #EB2019; }
  .cgip-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .cgip-bc-sep img { width: 24px; height: 24px; display: block; }
  .cgip-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .cgip-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .cgip-main-section { padding: 80px 0 120px 0; }
  .cgip-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .cgip-article { flex: 1; min-width: 0; }

  .cgip-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .cgip-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .cgip-meta-item:last-child { border-right: none; padding-right: 0; }
  .cgip-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .cgip-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 20px;
  }

  .cgip-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .cgip-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .cgip-article-body p { margin-bottom: 20px; }
  .cgip-article-body p:last-child { margin-bottom: 0; }

  .cgip-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }
  .cgip-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    margin: 0px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet ul list */
  .cgip-article-body ul {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .cgip-article-body ul li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .cgip-article-body ul li::before {
    content: '•';
    font-weight: 700; color: #202020;
    flex-shrink: 0; font-size: 18px; line-height: 160%;
  }
  .cgip-article-body ul li > span { flex: 1; }

  .cgip-article-body strong { font-weight: 600; color: #202020; }

  /* Comparison table */
  .cgip-table-wrapper {
    width: 100%; overflow-x: auto; margin: 20px 0 30px 0;
  }
  .cgip-table {
    width: 100%; border-collapse: collapse;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; color: #202020;
  }
  .cgip-table th, .cgip-table td {
    border: 1px solid #B8B8B8;
    padding: 20px 30px;
    text-align: left;
    line-height: 120%;
  }
  .cgip-table th {
    font-weight: 600; background: #F6F6F6;
  }
  .cgip-table td { font-weight: 400; }
  .cgip-table tbody tr:nth-child(odd)  { background-color: #ffffff; }
  .cgip-table tbody tr:nth-child(even) { background-color: #F6F6F6; }

  .cgip-red-link {
    color: #EB2019; text-decoration: underline; font-weight: 600;
    display: block; margin-bottom: 20px;
  }
  .cgip-red-link:hover { opacity: 0.8; }

  .cgip-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .cgip-red-link-plain:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .cgip-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .cgip-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .cgip-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .cgip-nav-btn:hover { color: #EB2019; }
  .cgip-nav-btn img { width: 40px; height: 40px; display: block; }

  .cgip-share-icons { display: flex; align-items: center; gap: 20px; }
  .cgip-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .cgip-share-icon:hover { opacity: 0.85; }
  .cgip-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .cgip-sidebar { flex: 0 0 475px; }
  .cgip-sidebar-block { margin-bottom: 60px; }
  .cgip-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .cgip-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .cgip-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .cgip-recent-item:hover .cgip-recent-title { color: #EB2019; }
  .cgip-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .cgip-recent-body { flex: 1; min-width: 0; }
  .cgip-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .cgip-social-icons { display: flex; align-items: center; gap: 30px; }
  .cgip-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .cgip-social-icon:hover { opacity: 0.8; }
  .cgip-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .cgip-hero             { height: 350px; }
    .cgip-hero-content     { padding: 0 32px; }
    .cgip-hero-title       { font-size: 30px; }
    .cgip-hero-divider     { width: 100%; max-width: 575px; }
    .cgip-breadcrumb       { padding: 24px 0 0 0; }
    .cgip-breadcrumb-inner { padding: 0 32px; }
    .cgip-inner            { padding: 0 32px; }
    .cgip-main-section     { padding: 48px 0 60px 0; }
    .cgip-main-row         { flex-direction: column; gap: 48px; }
    .cgip-sidebar          { flex: none; width: 100%; }
    .cgip-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .cgip-hero             { height: 360px; }
    .cgip-hero-content     { padding: 0 16px; }
    .cgip-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .cgip-hero-divider     { width: 100%; }
    .cgip-hero-subtitle    { font-size: 14px; }
    .cgip-breadcrumb       { padding: 30px 0 0 0; }
    .cgip-breadcrumb-inner { padding: 0 16px; }
    .cgip-bc-item          { font-size: 14px; gap: 14px; }
    .cgip-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .cgip-bc-sep img       { width: 22px; height: 22px; }
    .cgip-inner            { padding: 0 16px; }
    .cgip-main-section     { padding: 30px 0 60px 0; }
    .cgip-main-row         { flex-direction: column; gap: 60px; }
    .cgip-sidebar          { flex: none; width: 100%; }
    .cgip-article-title    { font-size: 20px; margin-bottom: 15px; }
    .cgip-article-body     { font-size: 14px; }
    .cgip-article-body p   { margin-bottom: 15px; }
    .cgip-article-body ul  { margin: 20px 0 20px 0; gap: 10px; }
    .cgip-article-body ul li { font-size: 14px; }
    .cgip-article-body strong { font-size: 14px; }
    .cgip-table            { font-size: 12px; }
    .cgip-table th, .cgip-table td { padding: 33px 8px; }
    .cgip-meta-item        { font-size: 14px; }
    .cgip-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .cgip-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .cgip-h2               { font-size: 16px; margin: 20px 0 0px 0; }
    .cgip-heading          { font-size: 16px; margin: 30px 0 15px 0; }
    .cgip-nav-btn img      { width: 24px; height: 24px; }
    .cgip-nav-btn          { font-size: 14px; }
    .cgip-share-icon img   { width: 34px; height: 34px; }
    .cgip-sidebar-title    { font-size: 20px; }
    .cgip-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function ComprehensiveGuideIGBTPowerModule() {
  return (
    <div className="cgip">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="cgip-hero">
        <img className="cgip-hero-bg" src={HeroBgImg} alt="A Comprehensive Guide to IGBT Power Module Hero" />
        <div className="cgip-hero-overlay" />
        <div className="cgip-hero-content">
          <h1 className="cgip-hero-title">
            A Comprehensive Guide to IGBT Power Module
          </h1>
          <hr className="cgip-hero-divider" />
          <p className="cgip-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="cgip-breadcrumb" aria-label="Breadcrumb">
        <div className="cgip-breadcrumb-inner">
          <a href="/" className="cgip-bc-item">Home</a>
          <span className="cgip-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="cgip-bc-item">News &amp; Updates</a>
          <span className="cgip-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="cgip-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="cgip-main-section">
        <div className="cgip-inner">
          <div className="cgip-main-row">

            {/* ── ARTICLE ── */}
            <article className="cgip-article">

              {/* Meta bar */}
              <div className="cgip-meta-bar">
                <span className="cgip-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="cgip-meta-item"><img src={CalendarIcon} alt="date" /> April 28, 2025</span>
                <span className="cgip-meta-item"><img src={ClockIconImg} alt="time" /> 10:31 am</span>
                <span className="cgip-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="cgip-article-title">
                A Comprehensive Guide to IGBT Power Module
              </h1>

              {/* Body */}
              <div className="cgip-article-body">

                <p>Insulated Gate Bipolar Transistor (IGBT) modules are vital components in modern power electronics. They combine the ease of control of MOSFETs with the high current and low saturation voltage capability of BJTs. IGBT modules enable efficient and reliable switching in high-power applications, such as industrial motor drives, renewable energy systems, and electric vehicles.</p>

                {/* Article image */}
                <img className="cgip-article-img" src={ArticleImg} alt="A Comprehensive Guide to IGBT Power Module" />

                <p>In this blog, we will explain everything you need to know about IGBT modules—their working principles, configurations, applications, and how to choose the right one for your system.</p>

                <span className="cgip-h2">What Are IGBT Modules?</span>

                <p><strong>IGBT modules</strong> are packaged power semiconductor devices containing multiple IGBTs and freewheeling diodes connected in various topologies. These modules handle high voltages and currents, allowing them to operate efficiently in high-power applications.</p>

                <span className="cgip-heading">Key Features:</span>

                <ul>
                  <li><span>High efficiency and fast switching</span></li>
                  <li><span>Rugged structure with high current-carrying capability</span></li>
                  <li><span>Excellent thermal performance</span></li>
                  <li><span>Reduced component count in circuit designs</span></li>
                </ul>

                <span className="cgip-h2">How Do IGBT Modules Work?</span>

                <p>IGBT modules switch electrical signals at high speeds, reducing power loss during the transition between on and off states. The transistor conducts when a voltage is applied to its gate terminal, allowing current to flow from the collector to the emitter. The module incorporates diodes to handle reverse recovery currents.</p>

                <span className="cgip-heading">Topologies of IGBT Modules</span>

                <p>IGBT modules are available in various configurations depending on the application:</p>

                <ul>
                  <li><span><strong>Half-bridge:</strong> Most commonly used in inverters and motor drives.</span></li>
                  <li><span><strong>Full-bridge (H-bridge):</strong> For bidirectional control in high-performance drives.</span></li>
                  <li><span><strong>Chopper:</strong> Used for DC voltage regulation.</span></li>
                  <li><span><strong>Three-level NPC/ANPC:</strong> Offers lower switching losses in medium-voltage applications.</span></li>
                </ul>

                <span className="cgip-heading">Benefits of IGBT Modules in Industrial Systems</span>

                <p>IGBT modules are central to high-efficiency systems across industries. Here's why they're preferred:</p>

                <ul>
                  <li><span><strong>Energy Efficiency:</strong> High-speed switching minimizes energy loss.</span></li>
                  <li><span><strong>Compact Design:</strong> Fewer discrete components mean smaller PCB space.</span></li>
                  <li><span><strong>High Reliability:</strong> Designed for long operating life even under harsh conditions.</span></li>
                  <li><span><strong>Thermal Management:</strong> Effective heat dissipation ensures safe operation.</span></li>
                </ul>

                <span className="cgip-heading">Applications of IGBT Modules</span>

                <p>IGBT modules are indispensable in multiple industries. Some key application areas include:</p>

                <span className="cgip-h2">Renewable Energy</span>

                <p>IGBT modules are used in solar inverters and wind turbine converters, which help regulate power flow and optimize energy conversion.</p>

                <span className="cgip-h2">Electric Vehicles (EVs)</span>

                <p>Used in powertrains, battery management systems, and AC-DC power supplies, enabling efficient propulsion and regenerative braking.</p>

                <span className="cgip-h2">Industrial Automation</span>

                <p>Power motor drives and welding equipment with consistent performance and reduced electromagnetic interference.</p>

                <span className="cgip-h2">Rail Traction</span>

                <p>Enable energy-efficient control of propulsion systems in locomotives and metro systems.</p>

                <span className="cgip-heading">Recent Advancements in IGBT Module Technology</span>

                <ul>
                  <li><span><strong>Integration of Wide Bandgap Semiconductors:</strong><br />
                  Recent innovations have seen the incorporation of wide bandgap materials like silicon carbide (SiC) into IGBT modules. SiC-based IGBTs offer lower power losses and superior thermal conductivity, making them ideal for high-demand applications such as electric vehicles (EVs) and industrial automation. These advancements enable more compact, high-power modules that enhance the efficiency of power electronic systems across various sectors, including consumer electronics and renewable energy.</span></li>

                  <li><span><strong>Advancements in Manufacturing Techniques:</strong><br />
                  Hitachi Energy has introduced a 300 mm wafer technology for 1200V IGBT devices, marking a significant leap in semiconductor manufacturing. This development increases chip production capacity and allows for more complex structures within IGBTs, enhancing their performance in high-power applications.</span></li>

                  <li><span><strong>Market Growth Driven by Electrification:</strong><br />
                  The global IGBT devices and modules market was valued at USD 5.40 billion in 2024 and is projected to reach USD 9.80 billion by 2033, growing at a CAGR of 7.1%. This growth is fueled by the increasing electrification of transportation, particularly the surge in EV production, which relies heavily on efficient power electronics for motor drives and battery charging systems.</span></li>

                  <li><span><strong>Enhanced Efficiency in Power Modules:</strong><br />
                  Infineon Technologies has unveiled its EDT3 IGBT modules, which achieve up to 20% lower total losses at high loads compared to previous generations. These modules are designed to meet the demands of applications requiring high efficiency and reliability, such as inverters and power supplies.</span></li>
                </ul>

                <span className="cgip-heading">Choosing the Right IGBT Module</span>

                <p>When selecting an IGBT module, consider the following:</p>

                <ul>
                  <li><span><strong>Voltage Rating:</strong> Should exceed the maximum voltage in your circuit.</span></li>
                  <li><span><strong>Current Rating:</strong> Must support peak and continuous current requirements.</span></li>
                  <li><span><strong>Switching Frequency:</strong> High-frequency applications need modules optimized for speed.</span></li>
                  <li><span><strong>Package Type:</strong> Affects mounting, cooling, and integration ease.</span></li>
                  <li><span><strong>Thermal Management Needs:</strong> A good thermal interface improves reliability.</span></li>
                </ul>

                <span className="cgip-h2">Comparison: IGBT Modules vs. Other Power Devices</span>

                <div className="cgip-table-wrapper">
                  <table className="cgip-table">
                    <thead>
                      <tr>
                        <th>Feature</th>
                        <th>IGBT Modules</th>
                        <th>MOSFET Modules</th>
                        <th>Thyristor Modules</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Voltage Range</td>
                        <td>Up To 6500V</td>
                        <td>Typically &lt; 1000V</td>
                        <td>Up To 1200V</td>
                      </tr>
                      <tr>
                        <td>Current Capability</td>
                        <td>Very High</td>
                        <td>Moderate</td>
                        <td>High</td>
                      </tr>
                      <tr>
                        <td>Switching Speed</td>
                        <td>Moderate</td>
                        <td>Very High</td>
                        <td>Low</td>
                      </tr>
                      <tr>
                        <td>Efficiency</td>
                        <td>High At High Voltage</td>
                        <td>High At Low Voltage</td>
                        <td>Low</td>
                      </tr>
                      <tr>
                        <td>Application Focus</td>
                        <td>Industrial, EVs</td>
                        <td>Consumer Electronics</td>
                        <td>Legacy Systems</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <span className="cgip-heading">Best Practices for Integrating IGBT Modules</span>

                <ul>
                  <li><span><strong>Use gate drivers with proper voltage levels and protections.</strong></span></li>
                  <li><span><strong>Install adequate heat sinks or cooling systems to manage thermal loads.</strong></span></li>
                  <li><span><strong>Implement snubber circuits to handle voltage spikes.</strong></span></li>
                  <li><span><strong>Design PCB layouts to minimize stray inductance.</strong></span></li>
                </ul>

                <span className="cgip-heading">Industry Trends and Innovations</span>

                <p>With rising demand for green energy and smart transportation, IGBT modules are evolving rapidly:</p>

                <ul>
                  <li><span><strong>Silicon Carbide (SiC) IGBTs:</strong> Offer higher switching frequencies and thermal tolerance.</span></li>
                  <li><span><strong>Digital Gate Control:</strong> Improves efficiency through real-time parameter tuning.</span></li>
                  <li><span><strong>Integrated Modules:</strong> Combine IGBT, driver, and protection features in one unit.</span></li>
                </ul>

                <span className="cgip-h2">Why IGBT Modules Matter for the Future</span>

                <p>As industries shift toward electrification and energy efficiency, the demand for IGBT modules will continue to grow. These power devices are at the heart of converting, controlling, and optimizing electricity for everything from smart grids to autonomous vehicles.</p>

                <p>Engineers can design more sustainable and high-performing systems by understanding how IGBT modules work and integrating them correctly.</p>

                <span className="cgip-h2">Final Thoughts</span>

                <p>IGBT modules have revolutionized power electronics by combining high efficiency with robust performance. These modules, from industrial motor drives to cutting-edge electric vehicles, are indispensable for modern energy management.</p>

                <p>To stay competitive, manufacturers and designers should prioritize quality IGBT modules, leverage advanced topologies, and implement best practices in system design.</p>

                <p>Are you looking to upgrade your power systems with high-performance IGBT modules? <strong>Explore more with us!</strong></p>

                <a href="/igbt-module-portfolio" className="cgip-red-link">Check Our IGBT Module Portfolio</a>

              </div>

              {/* ── Bottom row ── */}
              <div className="cgip-bottom-row">
                <div className="cgip-bottom-nav">
                  <a href="/news/previous" className="cgip-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="cgip-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="cgip-share-icons">
                  <a href="#" className="cgip-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="cgip-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="cgip-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="cgip-sidebar">

              {/* Recent Posts */}
              <div className="cgip-sidebar-block">
                <p className="cgip-sidebar-title">Recent Posts</p>
                <div className="cgip-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="cgip-recent-item">
                      <img src={post.img} alt={post.title} className="cgip-recent-img" />
                      <div className="cgip-recent-body">
                        <span className="cgip-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="cgip-sidebar-block">
                <p className="cgip-sidebar-title">Social Media</p>
                <div className="cgip-social-icons">
                  <a href="#" className="cgip-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="cgip-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}